import axios from 'axios'
import {AuthModel, BaseReturnApi, UserModel} from './_models'
import {TicketContentModel} from "../../../pages/tikets/core/_model";

const API_URL = process.env.REACT_APP_API_URL

export const GET_USER_BY_ACCESSTOKEN_URL = `${API_URL}/api/v3/UserConnect/CheckTokenIsValid`
export const LOGIN_URL = `${API_URL}/api/v3/UserConnect/Token`
export const REGISTER_URL = `${API_URL}/register`
export const REQUEST_PASSWORD_URL = `${API_URL}/forgot_password`

export function ChangeDetails (post : any){
  const fd = new FormData();
  fd.append('FullName', post.FullName);
  fd.append('ClientType', post.ClientType);
  fd.append('NationalCode', post.NationalCode);
  fd.append('Phone', post.Phone);
  fd.append('Address', post.Address);
  fd.append('PostalCode', post.PostalCode);
  if(post.Avatar){
    fd.append('Avatar', post.Avatar,post.Avatar.name);
  }
  return axios.post<UserModel>(`${API_URL}/api/v3/UserConnect/Update`,fd)
}
export function getCaptcha(){
  return axios.get<string>(`${API_URL}/api/v3/UserConnect/Captcha`)
}
// Server should return AuthModel
export function login(email: string, password: string,captcha : string) {

  return axios.post<AuthModel>(LOGIN_URL, {
    username : email,
    password : password,
    grant_type : 'password',
    captcha
  })
}

// Server should return AuthModel
export function register(
  email: string,
  firstname: string,
  lastname: string,
  password: string,
  password_confirmation: string
) {
  return axios.post(REGISTER_URL, {
    email,
    first_name: firstname,
    last_name: lastname,
    password,
    password_confirmation,
  })
}
export function UpdatePasswordDefault (oldPassword : string , newPassword : string , confirmPassword : string){
  const post ={
    curentpassword : oldPassword ,
    newpassword : newPassword ,
    repassword : confirmPassword
  }
  return axios.post(`${API_URL}/api/v3/UserConnect/UpdatePassword`,post)
}
// Server should return object => { result: boolean } (Is Email in DB)
export function requestPassword(mobile: string , captcha : string) {
  return axios.post<{result: BaseReturnApi<string>}>(`${API_URL}/api/v3/UserConnect/ResetPasswordByMobile`, {
    mobile,
    captcha
  })
}
export function requestPasswordSubmit(mobile: string , captcha : string,token:string,newPassword :string) {
  return axios.post<{result: BaseReturnApi<boolean>}>(`${API_URL}/api/v3/UserConnect/ResetPasswordByCode`, {
    mobile,
    captcha,
    token,
    newPassword
  })
}
export function getUserByToken(token: string) {
  return axios.post<UserModel>(GET_USER_BY_ACCESSTOKEN_URL, {
    api_token: token,
  })
}
